import { Outlet } from 'react-router';

import useDocumentTitle from '@/hooks/useDocumentTitle';

const CaseResolutionSection = () => {
  useDocumentTitle({
    resourceTitle: 'Resoluciones',
    showTitle: 'Resolución {id}',
  });

  return (
    <div className="CaseResolutionSection MainSection">
      <Outlet />
    </div>
  );
};

export default CaseResolutionSection;
